import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSingleObjetivo } from "../../../../context/SuperAdmin/OASContexts/SingleObjetivoContext";
import { EditIndicadorFields } from "../../../../interfaces/SuperAdmin/Pages/iDataIndicador";
const EditIndicadorModal = () => {
  const {
    isEditModalOpen,
    toggleEditModal,
    toEditIndicador,
    indicadorEdit,
    isEditing,
  } = useSingleObjetivo();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm<EditIndicadorFields>();

  // Función para manejar el envío del formulario
  const handleSubmitForm = (data: EditIndicadorFields) => {
    if (toEditIndicador) {
      indicadorEdit(data, toEditIndicador.id_indicador);
    }
  };

  const handleClose = () => {
    if (!isEditing) {
      reset();
      toggleEditModal(false);
    }
  };

  useEffect(() => {
    if (toEditIndicador) {
      reset({
        nombre: toEditIndicador.nombre,
      });
    }
  }, [toEditIndicador]);

  return (
    <Modal
      open={isEditModalOpen}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component="form"
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <Typography variant="h6" component="h2">
          Editar indicador
        </Typography>

        {/* Campo Nombre */}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Contenido
          </Typography>
          <Controller
            name="nombre"
            control={control}
            rules={{ required: "El nombre es obligatorio" }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                margin="normal"
                error={!!errors.nombre}
                helperText={errors.nombre?.message}
                disabled={isEditing}
              />
            )}
          />
        </Box>

        <Box sx={{ mt: 3, textAlign: "right" }}>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isEditing}
            type="submit"
          >
            {isEditing ? "Guardando" : "Guardar"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditIndicadorModal;
